<template>
  <div
    v-if="marker"
    class="marker-tooltip-floating"
    :style="tooltipStyle"
  >
    <div class="tooltip-header">
      <span class="tooltip-badge" :class="marker.type">
        {{ marker.type === 'note' ? '📝 Nota' : '❓ Encuesta' }}
      </span>
      <span class="tooltip-time">{{ formattedTime }}</span>
    </div>

    <div class="tooltip-body">
      <template v-if="marker.type === 'note'">
        <div class="tooltip-title">{{ marker.data.title || 'Nota sin título' }}</div>
        <div v-if="marker.data.content" class="tooltip-preview">
          {{ truncateText(marker.data.content, 60) }}
        </div>
      </template>

      <template v-else-if="marker.type === 'survey'">
        <div class="tooltip-title">{{ marker.data.question || 'Encuesta' }}</div>
        <div class="survey-status-tag" :class="{ 'answered': marker.data.answered }">
          {{ marker.data.answered ? '✓ Respondida' : '⏳ Pendiente' }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { PlayerService } from '@/services/player.service';

export default {
  name: 'MarkerTooltip',
  props: {
    marker: {
      type: Object,
      default: null
    },
    position: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    }
  },
  computed: {
    formattedTime() {
      return this.marker ? PlayerService.formatTime(this.marker.time) : '00:00';
    },
    tooltipStyle() {
      return {
        left: `${this.position.x}px`,
        top: `${this.position.y}px`
      };
    }
  },
  methods: {
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substr(0, maxLength) + '...' : text;
    }
  }
};
</script>

<style scoped>
.marker-tooltip-floating {
  position: fixed;
  transform: translate(-50%, -100%);
  margin-top: -8px;
  background: rgba(18, 24, 38, 0.92);
  backdrop-filter: blur(10px);
  color: #ffffff;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  z-index: 1000;
  max-width: 220px;
  font-family: inherit;
  font-size: 12px;
}

.tooltip-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.tooltip-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
}

.tooltip-badge.note {
  background: rgba(255, 217, 61, 0.25);
  color: #FFD93D;
  border: 1px solid rgba(255, 217, 61, 0.4);
}

.tooltip-badge.survey {
  background: rgba(107, 203, 119, 0.25);
  color: #6BCB77;
  border: 1px solid rgba(107, 203, 119, 0.4);
}

.tooltip-time {
  font-size: 11px;
  color: #a0aec0;
  font-weight: 500;
}

.tooltip-title {
  font-weight: 600;
  color: #f7fafc;
  line-height: 1.3;
}

.tooltip-preview {
  color: #cbd5e0;
  font-size: 11px;
  margin-top: 2px;
}

.survey-status-tag {
  display: inline-block;
  margin-top: 4px;
  font-size: 10px;
  color: #f6ad55;
}

.survey-status-tag.answered {
  color: #68d391;
}
</style>
